export default function SleepMode() {
  return <div className="fixed inset-0 bg-black z-[1000]" />;
}
